import { FC, useEffect } from 'react';
// import cs from 'classnames';
// import styles from './entry.module.less';
import V2FormInputNumber from '@/common/components/Form/V2FormInputNumber/V2FormInputNumber';
import { isNotEmpty } from '@lhb/func';

/**
 * @Description 不区分年份的表格（单行内展示两个字段）
 */
const SpecialInput: FC<{
  form: any;
  formItemData: any;
  disabled?: boolean;
  moduleConfig: any;
  record: any;
  columnItem: any;
  onChange: any;
}> = ({
  form,
  formItemData,
  disabled,
  moduleConfig,
  record,
  columnItem,
  onChange
}) => {
  const propertyIdentification = formItemData.identification;
  const { defaultValue } = record || {};

  const fieldData = (columnItem.dataIndex === 'name1' || columnItem.dataIndex === 'value1') ? (record?.dataInRow?.length > 0 ? record?.dataInRow[0] : null) : (record?.dataInRow?.length > 1 ? record?.dataInRow[1] : null);

  const fieldName = [propertyIdentification, moduleConfig.key, fieldData?.key];

  useEffect(() => {
    defaultValue && form.setFieldValue(fieldName, defaultValue);
  }, [defaultValue]);

  const handleBlur = () => {
    // console.log('YearDataInput handleBlur');
    onChange && onChange();
  };

  const renderInput = (fieldData: any) => {
    return <V2FormInputNumber
      formItemConfig={{
        noStyle: true
      }}
      min={isNotEmpty(fieldData.min) ? fieldData.min : 0}
      max={isNotEmpty(fieldData.max) ? fieldData.max : (fieldData.unit === '%' ? 100 : 999999999)}
      name={fieldName}
      placeholder={fieldData.disabled ? '自动计算' : (disabled ? '未输入' : '请输入')}
      form={form}
      disabled={disabled || !!fieldData?.disabled}
      rules={[{ required: !!fieldData.required, message: `请输入${fieldData.name}` }]}
      config={{
        addonAfter: fieldData?.unit || '',
        precision: fieldData?.precision || (record.unit === '%' ? 1 : 0),
        // onPressEnter: save,
      }}
      blur={handleBlur}
    />;
  };

  const renderName = (fieldData: any) => {
    return <>
      {fieldData?.required ? <span className='c-f23'>*</span> : ' '}{fieldData.name}
    </>;
  };

  return fieldData ? (columnItem?.isInput ? renderInput(fieldData) : renderName(fieldData)) : <></>;
};

export default SpecialInput;
